import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { QcArea, QcType } from '../models/qc-master';
import * as _ from 'underscore';




@Injectable({
  providedIn: 'root'
})
export class QualityControlStructureService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getQcAreas(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }


    return this.httpClient.get<QcArea[]>(`${this.basePath}/api/qcareas`,
      {
        params: queryParameters,
      }
    );
  }

  public getQcArea(id: number): Observable<QcArea> {

    return this.httpClient.get<QcArea>(`${this.basePath}/api/qcareas/${id}`);
  }

  public postQcArea(value: QcArea): Observable<QcArea> {
    return this.httpClient.post<QcArea>(`${this.basePath}/api/qcArea`, value);
  }

  public putQcArea(value: QcArea): Observable<QcArea> {
    return this.httpClient.put<QcArea>(`${this.basePath}/api/qcAreas/${value.id}`, value);
  }

  public deleteQcArea(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/qcareas/${id}`);
  }


  public getQcTypes(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('includeInactive', <any>includeInactive);
    }

    return this.httpClient.get<QcType[]>(`${this.basePath}/api/QcTypes`,
      {
        params: queryParameters,
      }
    );
  }

  public getQcType(id: number): Observable<QcType> {

    return this.httpClient.get<QcType>(`${this.basePath}/api/QcTypes/${id}`);
  }

  public postQcType(value: QcType): Observable<QcType> {
    return this.httpClient.post<QcType>(`${this.basePath}/api/QcTypes`, value);
  }

  public putQcType(value: QcType): Observable<QcType> {
    return this.httpClient.put<QcType>(`${this.basePath}/api/QcTypes/${value.id}`, value);
  }

  public deleteQcType(id: number): Observable<any> {
    return this.httpClient.delete(`${this.basePath}/api/QcTypes/${id}`);
  }

}
